
import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
export class VehicleAssignmentDto {
    @ApiProperty()
    @IsOptional()
    @IsNumber()
    vehicleAssignId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Assigned Date should not be empty" })
    assignedDate: Date;

    @ApiProperty()
    @IsNotEmpty({ message: "driver should not be empty" })
    @IsNumber()
    driverId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "vehicle should not be empty" })
    @IsNumber()
    vehicleId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Harvesting Date should not be empty" })
    harvestingDate: Date;

    @ApiProperty({
        enum: HarvestingTime
    })
    @IsNotEmpty({ message: "Harvesting Time should not be empty" })
    @IsEnum(HarvestingTime)
    harvestingTime: HarvestingTime;

    @ApiProperty()
    @IsNotEmpty({ message: "Indent should not be empty" })
    @IsNumber()
    indentId: number;
    @ApiProperty()
    isActive: boolean;
    createdAt : Date;
    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    createdUser: string;

    @ApiProperty()
    @IsOptional()
    updatedUser : string;
    @ApiProperty()
  versionFlag : number;
}